import {
  index,
  integer,
  jsonb,
  pgTable,
  serial,
  text,
  timestamp,
} from "drizzle-orm/pg-core";
import { createSchemaFactory } from "drizzle-zod";
import { z } from "zod";

const { createInsertSchema, createSelectSchema } = createSchemaFactory({
  zodInstance: z,
});

export const appEvents = pgTable(
  "app_events",
  {
    id: serial().primaryKey(),
    type: text().notNull(),
    resourceType: text().notNull(),
    resourceId: integer().notNull(),
    metadata: jsonb(),
    processedAt: timestamp(),
    attempts: integer().notNull().default(0),
    lastError: text(),
    createdAt: timestamp().$defaultFn(() => new Date()),
  },
  (table) => [
    index("app_events_type_processed_idx").on(table.type, table.processedAt),
    index("app_events_resource_idx").on(table.resourceType, table.resourceId),
  ],
);

export const selectAppEventSchema = createSelectSchema(appEvents);
export const createAppEventSchema = createInsertSchema(appEvents).omit({
  id: true,
});

export type AppEvent = z.infer<typeof selectAppEventSchema>;
export type CreateAppEvent = z.infer<typeof createAppEventSchema>;
